export default __webpack_public_path__ + "static/media/closeBtnGray.ed5a66bd.svg";